import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-auto-logout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './auto-logout.component.html',
  styleUrls: ['./auto-logout.component.scss'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, TranslateModule],
})
export class AutoLogoutComponent {
  constructor(
    public dialogRef: MatDialogRef<AutoLogoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { warn: false }
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  ok(): void {
    this.dialogRef.close(this.data.warn);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
